import { Box } from "@mui/material";
import React, { useRef, useState } from "react";
import AHMIS, { API_URL } from "../../../api/api";
import AddAlertMessage from "../../../components/alert/Alert";
import { ERROR, REPORT_NOT_DRAWN, SOMETHING_WENT_WRONG, SUCCESS } from "../../../utils/constants";
import MessageBlock from "../../admin/components/message-block/MessageBlock";
import AvailableServices from "../available-services/AvailableServices";
import ReportHeader from "../component/report-header/ReportHeader";
import GauGharClinicSewaReport from "../gau-ghar-clinic-sewa-report/GauGharClinicSewaReport";
import NewOldPatientCount from "../new-old-patient-count/NewOldPatientCount";
import TypeOfHealthFacility from "../type-of-health-facility/TypeOfHealthFacility";

const MonthlyProgressReport = () => {
  const [monthlyProgressData, setMonthlyProgressData] = useState(null);
  const printComponentRef = useRef();

  const getReportData = (dateFrom, dateTo, healthClientId) => {
    // let nepaliMonths = ["BAISHAKH", "JESTHA", "ASAR", "SHRAWAN", "BHADAU", "ASWIN", "KARTIK", "MANSIR", "POUSH", "MAGH", "FALGUN", "CHAITRA"];
    // const url = `${API_URL.monthlyProgressReport}?dateFrom=${dateFrom}&dateTo=${dateTo}&healthClientId=${healthClientId}&fiscalYear=${DateUtils.getFiscalYearFromDate(DateUtils.getDateFromMilliseconds(dateTo))} &month=${nepaliMonths[parseInt(DateUtils.getSeparatedDateFromMilliseconds(dateFrom).month) - 1]}`;
    const url = `${API_URL.monthlyProgressReport}?dateFrom=${dateFrom}&dateTo=${dateTo}`;
    AHMIS.get(url).then(response => {
      const jsondata = response.data;
      if (jsondata.type === SUCCESS) {
        setMonthlyProgressData(jsondata.data);
      } else {
        AddAlertMessage({ type: jsondata.type, message: jsondata.message });
      }
    }).catch(error => {
      AddAlertMessage({ type: ERROR, message: `${SOMETHING_WENT_WRONG}: ${error.message}` });
    });
  };

  return (
    <>
      <ReportHeader
        title="मासिक प्रगती प्रतिवेदन फाराम"
        getReportData={getReportData}
        reportData={monthlyProgressData}
        printComponentRef={printComponentRef}
      />
      {monthlyProgressData ? (
        <Box ref={printComponentRef}>
          <NewOldPatientCount tableData={monthlyProgressData} />
          <GauGharClinicSewaReport />
          <TypeOfHealthFacility />
          <AvailableServices />
        </Box>
      ) : (
        <MessageBlock text={REPORT_NOT_DRAWN} />
      )
      }
    </>
  )
}

export default MonthlyProgressReport;